import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { AppDispatch } from "store";

export const useGlobalHooks = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { t, i18n } = useTranslation();

  return { dispatch, t, i18n };
};
